<template>
  <div>
    <PageHeader v-if="!isMobile" :title="'About'" :link="{ path: '/', label: 'EER' }" />
    <div v-if="about" :class="isMobile ? 'mt-20' : 'mt-24'">
      <div class="mx-auto my-0">
        <div class="flex flex-col md:flex-row">
          <div class="w-full md:w-1/2 lg:w-1/3 p-4">
            <h1>About <i>Experimenting, Experiencing, Reflecting</i></h1>
            <div v-html="about.description" class="my-12" />

          </div>
          <div class="w-full md:w-1/2 lg:w-2/3">
            <div class="w-full flex flex-col lg:flex-row p-4">
              <div class="flex-grow-0 pr-8">
                <div class="mb-4">CORE</div>
                <h1
                  v-for="member in about.people['Core']"
                  :key="member.title"
                  class="cursor-pointer hover:underline"
                  v-on:click="$router.push(`/about/${member.slug}`)"
                >
                  {{ member.title }}
                </h1>
              </div>
              <div class="hidden md:block flex-grow py-4" style="height: 300px">
                <GridSix :scalarMode="true" :showColumns="3" />
              </div>
            </div>
            <div class="w-full p-4">
              <div v-for="(group, key) in about.people" :key="`group-${key}`" class="mb-8">
                <div v-if="key !== 'Core'">
                  <div class="mb-4">{{ key }}</div>
                  <h1
                    v-for="(member, index) in group"
                    :key="member.title"
                    class="inline-block"
                  >
                    <span class="cursor-pointer hover:underline" v-on:click="$router.push(`/about/${member.slug}`)">{{ member.title }}</span>
                    <span v-if="index < group.length - 1">,&nbsp;</span>
                  </h1>
                </div>
              </div>
              <div class="lg:col-count-2 lg:col-gap-lg" >
                <div class="mb-4">DESIGN PRINCIPLES</div>
                <div v-html="about.design_principles" />
              </div>
              <div class="mt-8">
                <div class="mb-4">WEBSITE</div>
                <div v-html="about.credits" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <PageFooter />
    </div>
    <div class="fixed top-0 left-0 w-full h-full -z-10 flex items-center justify-center">
      <Squiggle />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageHeader from '@/components/PageHeader'
import PageFooter from '@/components/PageFooter'
import GridSix from '@/components/GridSix'
import Squiggle from '@/components/Squiggle'

export default {
  name: 'About',

  metaInfo () {
    return {
      title: 'About'
    }
  },

  components: {
    PageHeader,
    PageFooter,
    GridSix,
    Squiggle
  },

  computed: {
    ...mapState(['about', 'isMobile']),
  },

  mounted () {
    this.$store.dispatch('getAbout')
  }
}
</script>
